import React from 'react';
import arrow from "../../../../styles/svg/arrow.svg";

const StatusChange = ({ oldValue, newValue }) => {
  return (
    <div className="d-flex align-items-center history-heading">
      <div className="old-status-box">
        <p className="old-status">{oldValue}</p>
      </div>
      <img className="arrow-img" src={arrow} alt="arrow" />
      <div className="new-status-box">
        <p className="new-status">{newValue}</p>
      </div>
    </div>
  );
};

export default StatusChange; 